import { useEffect, useLayoutEffect } from 'react';

/**
 * Fork from https://usehooks-ts.com/react-hook/use-isomorphic-layout-effect
 * This hook enables to switch between useEffect and useLayoutEffect following the execution environment.
 * (Prevent NextJs warning about the use of useLayoutEffect on server side)
 */
const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
